__webpack_require__.p = "/result/panchayat-2025/";